'use client';

import React from 'react';

import { StepupContextProvider } from './context/stepup-context';
import { StepupSourceProvider } from './context/stepup-source';
import { StepupOfferDialogContent } from './stepup-offer-dialog-content';

export const StepupOffer = () => {
  return (
    <StepupSourceProvider>
      <StepupContextProvider refetchStatusInterval={125 * 8}>
        <StepupOfferDialogContent />
      </StepupContextProvider>
    </StepupSourceProvider>
  );
};
